import { apiClient } from "@/lib/api";
import { fetchAllPages } from "@/lib/fetchAllPages";
import type {
  ActivityItem,
  ActivityItemCreate,
  ActivityItemUpdate,
} from "@/types";

export type ActivityItemCreateWithImage = ActivityItemCreate & {
  image?: File;
};

/** Backend cap: GET /activities/{activity_id}/items `limit` le=500. */
const ACTIVITY_ITEMS_PAGE_SIZE = 500;

/** Every catalog line of an activity (all pages). */
function list(activityId: string): Promise<ActivityItem[]> {
  return fetchAllPages(async (page) => {
    const response = await apiClient.get<ActivityItem[]>(
      `/activities/${activityId}/items`,
      { params: page },
    );
    return response.data;
  }, ACTIVITY_ITEMS_PAGE_SIZE);
}

export const activityItemService = {
  listMenu: (activityId: string): Promise<ActivityItem[]> => list(activityId),

  listService: async (activityId: string): Promise<ActivityItem[]> => {
    const items = await list(activityId);
    return items.filter((row) => row.menu_category == null);
  },

  create: async (
    activityId: string,
    data: ActivityItemCreateWithImage,
  ): Promise<ActivityItem> => {
    const { image, ...itemData } = data;
    const formData = new FormData();
    formData.append("data", JSON.stringify(itemData));
    if (image) {
      formData.append("image", image);
    }

    const response = await apiClient.post<ActivityItem>(
      `/activities/${activityId}/items`,
      formData,
    );
    return response.data;
  },

  update: async (
    activityId: string,
    itemId: string,
    data: ActivityItemUpdate,
  ): Promise<ActivityItem> => {
    const response = await apiClient.patch<ActivityItem>(
      `/activities/${activityId}/items/${itemId}`,
      data,
    );
    return response.data;
  },

  delete: async (activityId: string, itemId: string): Promise<void> => {
    await apiClient.delete(`/activities/${activityId}/items/${itemId}`);
  },
};
